export default __webpack_public_path__ + "images/a7f5cc2f20ebf4b2044c38d1a63866d2-Seed-talks.svg";